import * as React from 'react';
import { FormikProps } from 'formik';
import { useIntl } from 'react-intl';
import { CmdAlert } from '@commander-services/gui-components';
import FormikService from '../../../../Services/FormikService';
import SvgIconService from '../../../../Services/SvgIconService';
import usePageWithForm from '../../../../hooks/usePageWithForm';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import useAnalytics from '../../../../hooks/useAnalytics';

const logoSvg = SvgIconService.logo();

interface IModalForm extends FormikProps<any> {
  id: string;
  children: React.ReactNode;
  save: (values: any) => void;
  isButtonLoaderActive: boolean;
  alert: any;
  isDone: boolean;
}

export default function ModalForm(props: IModalForm): JSX.Element {
  usePageWithForm();
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  useDocumentTitle(f({ id: 'loginForm.login' }));

  const handleButtons = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    const errors = await props.validateForm();
    if (Object.keys(errors).length === 0) {
      props.save(props.values);
    } else {
      FormikService.setFieldsTouched(props.values, props.setTouched);
    }
  };

  const getAlertTranslations = () => {
    const alert = props.alert;
    if (alert) {
      alert.title = f({ id: alert.title });
      alert.message = f({ id: alert.message });
      return alert;
    }
    return null;
  };

  return (
    <div className="w-login-content">
      {!props.isDone && <CmdAlert id="activate-account-alert" data={getAlertTranslations()} />}
      <div className="b-login">
        <div className="headline">
          <img className="logo-svg" src={logoSvg} alt="logo" />
        </div>
        {!props.isDone ? (
          <form
            id={props.id}
            className="form-horizontal"
            onReset={() => {
              trackEvent(['Expired password', 'click', 'Reset form']);
              props.handleReset();
            }}
            onSubmit={() => {
              trackEvent(['Expired password', 'click', 'Submit form']);
              props.handleSubmit();
            }}
          >
            <div className="p-8">{props.children}</div>
            <div className="text-right">
              <div className="foot py-6 px-8">
                {props.isButtonLoaderActive ? (
                  <div className="e-button e-button--gray d-flex w-100">
                    <i className="cmd-icon-loader animation-spin" />
                  </div>
                ) : (
                  <button
                    type="button"
                    id="submitNewPassword"
                    onClick={handleButtons}
                    className="e-button e-button--gray d-flex w-100"
                    data-cy="button_submit_activate_account"
                    disabled={!props.isValid}
                  >
                    {f({ id: 'loginForm.passwordSave' })}
                  </button>
                )}
                <a href="/" title="" className="fs-3 mt-1 d-inline-block">
                  {f({ id: 'newPassword.login' })}
                </a>
              </div>
            </div>
          </form>
        ) : (
          <div>
            <div className="p-8">{f({ id: 'newPassword.done' })}</div>
            <div className="foot p-6">
              <a href="/" onClick={() => trackEvent(['Expired password', 'click', 'Login link'])} className="e-button e-button--gray d-flex w-100">
                {f({ id: 'newPassword.login' })}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
